import React, { Component } from 'react';
import './App.css';
import { ParallaxProvider } from 'react-scroll-parallax';
import Header from './Components/Header/Header';
import Yellow1 from './Components/Yellow1/Yellow1';
import LightBlue1 from './Components/LightBlue1/LightBlue1';
import DarkBlue from './Components/DarkBlue/DarkBlue';
import Red from './Components/Red/Red';
import Icons from './Components/Icons/Icons';
import Contacts from './Components/Contacts/Contacts';
import Footer from './Components/Footer/Footer';

class App extends Component {
  render() {
    return (
      <ParallaxProvider>
        <div className="App">
          <Header />
          <Yellow1 />
          <LightBlue1 />
          <DarkBlue />
          <Icons />
          <Red />
          <Contacts />
          <Footer />
        </div>
      </ParallaxProvider>
    );
  }
}

export default App;
